import {potrebGoalsCredit} from '@/static/pages/constants/creditRates';

/**
 * core/models/pages/home-page/ProfitPropositionsModel.js
 * core/models/pages/for-individuals/crediting/CreditingModel.js
 * core/models/pages/for-individuals/crediting/ConsumerLoanModel.js
 * core/models/pages/business-page/SelfemployedModel.js
*/
const potrebCreditSlide = {
    slideImg: {
        src: 'profit-propositions/credit/credit7.webp',
        alt: 'Кредит наличными',
    },
    slideTitle: {
        title: 'Кредит наличными',
        additionalClasses: ['profit-propositions-box_size'],
    },
    slideLink: '/for-individuals/crediting/consumer-loan/credit-for-all',
};

/**
 * core/models/pages/home-page/ProfitPropositionsModel.js
 * core/models/pages/business-page/SelfemployedModel.js
 * core/models/pages/for-individuals/crediting/CreditingModel.js
*/
const carLoanSlide = {
    slideImg: {
        src: 'profit-propositions/credit/credit3.webp',
        alt: 'Автокредит без страховки и комиссии',
    },
    slideTitle: {
        title: 'Автокредит',
    },
    slideValue: {
        value: 'без страховки и&nbsp;комиссии на&nbsp;любые новые и&nbsp;подержанные автомобили',
    },
    slideLink: '/for-individuals/crediting/car-loans',
};

/**
 * core/models/pages/for-individuals/crediting/CreditingModel.js
*/
const selfEmployedLoanSlide = {
    slideImg: {
        src: 'profit-propositions/credit/credit1.png',
        alt: 'Кредит для самозанятых',
    },
    slideTitle: {
        title: 'Для&nbsp;самозанятых',
    },
    slideValue: {
        value: 'Кредит и&nbsp;рефинансирование ранее полученных кредитов',
    },
    slideLink: '/for-individuals/crediting/self-employed',
};

/**
 * core/models/pages/for-individuals/crediting/ConsumerLoanModel.js
*/
const refinancingCreditSlide = {
    slideImg: {
        src: 'profit-propositions/credit/credit5.webp',
        alt: '',
    },
    slideTitle: {
        title: 'Рефинансирование потребительского кредита',
        additionalClasses: ['profit-propositions-box_size'],
    },
    slideLink: '/for-individuals/refinancing/credit-refinancing',
};

/***/
const potrebGoalsCreditSlide = {
    slideImg: {
        src: 'profit-propositions/credit/credit7.webp',
        alt: '',
    },
    slideTitle: {
        title: 'Потребительский кредит',
    },
    slideLink: '/for-individuals/crediting/consumer-loan/potreb-goals',
    slideValue: {
        value: 'на потребительские цели',
    },
    slideAddition: {
        prefix: 'от',
        rate: potrebGoalsCredit.rate,
        postfix: 'годовых',
    },
};

const firstLoanCredit = {
    slideImg: {
        src: 'slides/consumer-loan/first-credit-suggestion.webp',
        alt: 'Первый кредит',
    },
    slideTitle: {
        title: 'Первый кредит по&nbsp;сниженной ставке',
    },
    slideLink: '/for-individuals/crediting/consumer-loan#credit-calculator',
    target: '_self',
};

const carLoanPotrebSlide = {
    slideImg: {
        src: 'slides/consumer-loan/car-loan-slide-offer.jpg',
        alt: 'Кредит наличными на&nbsp;приобретение автомобиля',
    },
    slideTitle: {
        title: 'Кредит наличными<br>на&nbsp;приобретение<br>автомобиля',
    },
    slideValue: {
        value: 'Без&nbsp;обязательного страхования<br/>и&nbsp;прочих комиссий',
    },
    slideLink: '/for-individuals/crediting/consumer-loan/car-loan',
};

export {
    potrebCreditSlide,
    carLoanSlide,
    selfEmployedLoanSlide,
    refinancingCreditSlide,
    potrebGoalsCreditSlide,
    firstLoanCredit,
    carLoanPotrebSlide,
};
